// Lightweight quality checker - no external dependencies
// Basic spell check using common misspellings and grammar patterns

const COMMON_TYPOS = {
  'recieve': 'receive',
  'seperate': 'separate', 
  'definately': 'definitely',
  'occured': 'occurred',
  'managment': 'management',
  'experiance': 'experience',
  'responsabilities': 'responsibilities',
  'sucessful': 'successful',
  'achived': 'achieved',
  'anual': 'annual',
  'buisness': 'business',
  'competetive': 'competitive',
  'developement': 'development',
  'enviroment': 'environment',
  'maintainance': 'maintenance',
  'profesional': 'professional',
  'recomendation': 'recommendation',
  'tecnology': 'technology',
  'colaboration': 'collaboration'
};

const WEAK_PHRASES = [
  'responsible for',
  'duties included',
  'worked on',
  'helped with',
  'assisted in',
  'various tasks',
  'multiple projects',
  'stuff',
  'things',
  'etc'
];

const GRAMMAR_ISSUES = [
  /\b(very|really|quite|pretty|somewhat)\s+/gi, // Weak qualifiers
  /\b(i|me|my|myself)\b/gi, // First person (should be minimal)
  /\s{2,}/g, // Multiple spaces
  /[.]{2,}/g, // Multiple periods
  /[!]{2,}/g, // Multiple exclamation marks
];

export function qualityCheck(text) {
  if (!text) return { typoPenalty: 0, grammarPenalty: 0, typoCount: 0, grammarCount: 0, issues: [] };

  const issues = [];
  let typoCount = 0;
  let grammarCount = 0;

  // Check for common typos
  const words = text.toLowerCase().match(/\b[a-z]+\b/g) || [];
  words.forEach(word => {
    if (COMMON_TYPOS[word]) {
      typoCount++;
      issues.push(`Typo: "${word}" should be "${COMMON_TYPOS[word]}"`);
    }
  });

  // Check for weak phrases
  WEAK_PHRASES.forEach(phrase => {
    const regex = new RegExp(`\\b${phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
    const matches = text.match(regex);
    if (matches) {
      grammarCount += matches.length;
      issues.push(`Weak phrase: "${phrase}" - use stronger action verbs`);
    }
  });

  // Check grammar patterns
  GRAMMAR_ISSUES.forEach(pattern => {
    const matches = text.match(pattern);
    if (matches) {
      grammarCount += matches.length;
    }
  });

  const totalWords = words.length;
  const typoRate = totalWords > 0 ? typoCount / totalWords : 0;
  const grammarRate = totalWords > 0 ? grammarCount / totalWords : 0;

  // Calculate penalties (max 20 points each)
  const typoPenalty = Math.min(typoRate * 100 * 0.4, 20);
  const grammarPenalty = Math.min(grammarRate * 100 * 0.3, 20);

  return {
    typoPenalty: Math.round(typoPenalty * 10) / 10,
    grammarPenalty: Math.round(grammarPenalty * 10) / 10,
    typoCount,
    grammarCount,
    issues: issues.slice(0, 10) // Limit to top 10 issues
  };
} 